import {
  Action,
  ActionType,
  TemperatureAmountsResponse,
} from "models/dashboard/temperatureAmounts";
import createReducer from "../../createReducer";

export interface TemperatureAmountsReducerType {
  loading: boolean;
  error?: string;
  temperatureAmountsResponse?: TemperatureAmountsResponse;
}

const defaultState: TemperatureAmountsReducerType = {
  loading: false,
  error: undefined,
  temperatureAmountsResponse: undefined,
};

export const getTemperatureAmountsReducer =
  createReducer<TemperatureAmountsReducerType>(defaultState, {
    [ActionType.GET_TEMPERATURE_AMOUNTS_CHART](
      state: TemperatureAmountsReducerType
    ) {
      return {
        ...state,
        loading: true,
      };
    },

    [ActionType.GET_TEMPERATURE_AMOUNTS_CHART_ERROR](
      state: TemperatureAmountsReducerType,
      action: Action<number>
    ) {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    },

    [ActionType.GET_TEMPERATURE_AMOUNTS_CHART_SUCCESS](
      state: TemperatureAmountsReducerType,
      action: Action<number>
    ) {
      return {
        ...state,
        loading: false,
        error: null,
        temperatureAmountsResponse: action.payload,
      };
    },
  });
